module.exports = __webpack_public_path__ + "img/onlinePlatformTable-lg.0476a422.svg";